export enum ApiNaturalPartyOrLegalPartyCodeEnum {
    LegalParty = 'NNP',
    NaturalParty = 'NP',
}
